<template>
  <v-card class="with-shadow rounded" v-if="loaded">
    <v-card-title class="headline">
      Surat perbulan
    </v-card-title>
    <v-card-text>
      <BarChart v-if="loaded" :chartdata="chartData" :options="chartOptions" />
    </v-card-text>
  </v-card>
</template>

<script>
import BarChart from '../../chart/BarChart'
import { monthlyChart } from '@/services/dashboard'

export default {
  props: {
    id_pengolah: { type: Number, default: null }
  },
  components: { BarChart },
  data() {
    return {
      loaded: false,
      chartData: {
        labels: [],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { position: 'bottom' },
        scales: {
          xAxes: [
            {
              offset: true,
              gridLines: false,
              ticks: { padding: 10 }
            }
          ],
          yAxes: [
            {
              offset: true,
              gridLines: { drawBorder: false },
              ticks: { beginAtZero: true }
            }
          ]
        }
      }
    }
  },
  watch: {
    id_pengolah: function(value) {
      this.loadData(value)
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData(id_pengolah = null) {
      try {
        this.loaded = false
        const { data } = await monthlyChart(id_pengolah)
        this.chartData = data
      } catch (error) {
        // console.log(error)
      } finally {
        this.loaded = true
      }
    }
  }
}
</script>

<style></style>
